export default "__VITE_ASSET__DoDMmWG$__"